'use strict';

var _ = require('lodash');
var GridSaveScenarioButtonController = function GridSaveScenarioButtonController($scope, $rootScope, scenarioService, reoptPreviewDataUtilsService, saveButtonUtilsService) {
  var gridPanel = $scope.gridPanelScope;
  var reoptStatuses = scenarioService.getReoptStatuses();
  function validateChanges(overrideRows) {
    return _.isFunction($scope.customSaveValidation) ? $scope.customSaveValidation(overrideRows, gridPanel.syncGridApply('getboundrows')) : true;
  }
  function adjustDataBeforeSaving(overrideRows) {
    return _.isFunction($scope.customSaveDataAdjuster) ? $scope.customSaveDataAdjuster(overrideRows) : true;
  }
  $scope.saveChanges = function (saveToProd) {
    var overrideRows = saveButtonUtilsService.getEditedRows(gridPanel.jqxGridSettings);
    adjustDataBeforeSaving(overrideRows);
    if (validateChanges(overrideRows)) {
      $scope.triggerSaveModal(overrideRows, saveToProd);
    }
  };
  $scope.getMdReoptSaveData = function () {
    return {
      mdReoptKeyRow: gridPanel.reoptPreviewData && gridPanel.reoptPreviewData.mdReopt,
      previewMode: reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData)
    };
  };
  $scope.getNdReoptSaveData = function () {
    return {
      ndReoptKeyRow: gridPanel.reoptPreviewData && gridPanel.reoptPreviewData.ndReopt,
      previewMode: reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData)
    };
  };
  function getSaveReoptData() {
    if (reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData)) {
      return $scope.getMdReoptSaveData();
    } else if (reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData)) {
      return $scope.getNdReoptSaveData();
    }
  }
  $scope.triggerSaveModal = function (overrideRows, saveToProd) {
    var reoptSaveData = getSaveReoptData();
    $rootScope.$broadcast('user-overrides:save', {
      data: overrideRows,
      gridId: gridPanel.gridId,
      selectedRows: gridPanel.reoptPreviewData && gridPanel.reoptPreviewData.mdReopt,
      scenarioName: '',
      userAction: '',
      reoptSaveData: reoptSaveData,
      reoptPreviewData: gridPanel.reoptPreviewData
    }, Boolean(saveToProd));
  };
  $scope.triggerSave = function () {
    var rows = saveButtonUtilsService.getEditedRows(gridPanel.jqxGridSettings);
    var previewEnabled = reoptPreviewDataUtilsService.isPreview(gridPanel.reoptPreviewData);
    $rootScope.$broadcast('save-modal:getGridInfo', rows, gridPanel.gridId, null, null, previewEnabled);
  };
  $scope.onKeyboardChange = function () {
    $scope.saveChanges(true);
  };
  $scope.$on('save-modal:flight-analysis-recordChanges', $scope.triggerSave);
  $scope.$on('save-modal:market-analysis-recordChanges', $scope.triggerSave);
  function isButtonDisabled() {
    return isScenarioOptimizing() || noUnsavedUserAdjustments();
  }
  function isScenarioOptimizing() {
    return scenarioService.checkSelectedScenarioReoptStatus(reoptStatuses.optimizing);
  }
  function noUnsavedUserAdjustments() {
    return (scenarioService.checkSelectedScenarioReoptStatus(reoptStatuses.optimized) || scenarioService.checkSelectedScenarioReoptStatus(reoptStatuses.notOptimized)) && !gridPanel.hasUnsavedAdjustments();
  }
  function updateButtonDisabledStatus() {
    $scope.saveScenarioButtonDisabled = isButtonDisabled();
  }
  $scope.$on(gridPanel.screen + ':scenariosChanged', updateButtonDisabledStatus);
  $scope.$on('clearChangedValue', updateButtonDisabledStatus);
  $scope.$on('grid:cellValueChanged', function (event, change, gridId) {
    if (gridId === gridPanel.gridId) {
      updateButtonDisabledStatus();
    }
  });
};
GridSaveScenarioButtonController.$inject = ['$scope', '$rootScope', 'ScenarioService', 'ReoptPreviewDataUtilsService', 'SaveButtonUtilsService'];
module.exports = GridSaveScenarioButtonController;